var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7236 12.0827C9.57465 11.8252 9.29973 11.6667 9.00226 11.6667H4.51189L2.84505 9.99986L4.51084 8.33333H9.00226C9.29973 8.33333 9.57465 8.17476 9.7236 7.91727C10.4453 6.66968 11.7921 5.83333 13.3334 5.83333C15.6345 5.83333 17.5 7.69881 17.5 10C17.5 12.3012 15.6345 14.1667 13.3334 14.1667C11.7921 14.1667 10.4453 13.3303 9.7236 12.0827Z",
    stroke: "#272B30",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 9.99967C14.1665 10.4599 13.7934 10.833 13.3332 10.833C12.8729 10.833 12.4998 10.4599 12.4998 9.99967C12.4998 9.53944 12.8729 9.16634 13.3332 9.16634C13.7934 9.16634 14.1665 9.53944 14.1665 9.99967Z",
    stroke: "#272B30",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.801e4923faf970a1c8539e2356c38ea5.svg";
export { ForwardRef as ReactComponent };